import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const AudiFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Audi"
      slug="/lenders/mis-sold-audi-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default AudiFinancePage
